// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"96":"ca5d1558","177":"9ce92c7c","215":"5ed2ccb2","503":"d98b502d","649":"5202f514","953":"669bdb93"}[chunkId] + ".css";
};